import { Routes } from '@angular/router';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';
import { TicketComponent } from './ticket/ticket.component';

export const routes: Routes = [
    {
        path: ':community',
        component: TicketComponent,
    },
    {
        path: '404',
        component: NotFoundPageComponent,
    },
    {
        path: '**',
        component: NotFoundPageComponent,
    },
];
